import { i18n } from '@/i18n';
import { AreaKey, AreaLocalConfig } from '@/types/area';
import { MAINLAND_DIALOG_CONF, MAINLAND_MODULE_CONF } from './module-config/mainland';
import { MACAO_DIALOG_CONF, MACAO_MODULE_CONF } from './module-config/macao';
import { JAPAN_DIALOG_CONF, JAPAN_MODULE_CONF } from './module-config/japan';

// 投放数据
export * from './dp';

// ekyc channelId
export const EKYC_CHANNELID = 28;

/** 地区名字配置 */
export const AREA_CONF: { [key in AreaKey]: AreaLocalConfig } = {
  [AreaKey.MainLand]: {
    name: i18n('中國內地'),
    wujiConfigUrl: 'https://st.moneydata.hk/wuji/config/cross_travel/crossTravelIndexV2.json',
    /** 模块列表配置 */
    moduleListConfig: MAINLAND_MODULE_CONF,
    dialogListConfig: MAINLAND_DIALOG_CONF,
    /** 微信分享内容 */
    wxShareConf: {
      title: i18n('WeChat Pay HK已支持內地過百萬商戶！'),
      desc: i18n('自動換匯，內地消費直接港幣結算，享優惠匯率。'),
      imgUrl: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20230627185502/cross-travel.png',
      link: `https://prom.wechatpay.com.hk/cross-travel/index.shtml?adtag=share&area=${AreaKey.MainLand}`,
    },
    recommendImg: i18n('mainlandRecommendImg'),
  },
  [AreaKey.Macao]: {
    name: i18n('中國澳門'),
    wujiConfigUrl: 'https://st.moneydata.hk/wuji/config/cross_travel_macao/crossTravelMacaoV2.json',
    /** 模块列表配置 */
    moduleListConfig: MACAO_MODULE_CONF,
    dialogListConfig: MACAO_DIALOG_CONF,
    /** 微信分享内容 */
    wxShareConf: {
      title: i18n('WeChat Pay HK陪你澳門食買玩～'),
      desc: i18n('見到「微信支付」就可用！WeChat Pay HK 現已支持澳門近2萬家商戶，無論你想去邊，都可以使用WeChat Pay HK！'),
      imgUrl: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20230627185502/cross-travel.png',
      link: `https://prom.wechatpay.com.hk/cross-travel/index.shtml?adtag=share&area=${AreaKey.Macao}`,
    },
    recommendImg: i18n('macaoRecommendImg'),
  },
  [AreaKey.Japan]: {
    name: i18n('日本'),
    wujiConfigUrl: 'https://st.moneydata.hk/wuji/config/cross_travel_japan/crossTravelJapanV2.json',
    /** 模块列表配置 */
    moduleListConfig: JAPAN_MODULE_CONF,
    dialogListConfig: JAPAN_DIALOG_CONF,
    /** 微信分享内容 */
    wxShareConf: {
      title: i18n('WeChat Pay HK 已支持日本消費！'),
      desc: i18n('去日本旅遊也可使用WeChat Pay HK進行消費啦，無需換匯，匯率更優！點擊查看支持的商戶—>'),
      imgUrl: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20230627185502/cross-travel.png',
      link: `https://prom.wechatpay.com.hk/cross-travel/index.shtml?adtag=share&area=${AreaKey.Japan}`,
    },
    recommendImg: i18n('japanRecommendImg'),
  },
};

/** 默认头图配置 */
export const DEFAULT_HEADER_CONFIG = {
  areaKey: AreaKey.MainLand,
  areaName: AREA_CONF[AreaKey.MainLand].name,
  headerLogo: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20230628110746/mainland.png',
};
